var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.banners),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"3","lg":"6"}},[_c('c-item',{attrs:{"item":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }